import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';

@Component({
  selector: 'app-form-view, [app-form-view]',
  templateUrl: './form-view.component.html'
})
export class FormViewComponent {

  @Input() index: number;

  referenceFormTemplate: ControlTemplate;
  referenceBodyControlTemplates: ControlTemplate[];
  referenceCompletionControlTemplates: ControlTemplate[];

  @Input() set controlTemplate(formControlTemplate: ControlTemplate) {
    if (formControlTemplate) {
      this.referenceFormTemplate = formControlTemplate;
      this.referenceBodyControlTemplates = formControlTemplate?.body?.[this.index].controls;
      this.referenceCompletionControlTemplates = formControlTemplate?.completion?.controls;
    }
  }

  constructor(
  ) {
  }

}
